/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiSliderStyle {
}

export enum UiSliderStyle_Enum {
  FILL = 0,
  SEEK = 1,
  UNRECOGNIZED = -1,
}

export function uiSliderStyle_EnumFromJSON(object: any): UiSliderStyle_Enum {
  switch (object) {
    case 0:
    case "FILL":
      return UiSliderStyle_Enum.FILL;
    case 1:
    case "SEEK":
      return UiSliderStyle_Enum.SEEK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UiSliderStyle_Enum.UNRECOGNIZED;
  }
}

export function uiSliderStyle_EnumToJSON(object: UiSliderStyle_Enum): string {
  switch (object) {
    case UiSliderStyle_Enum.FILL:
      return "FILL";
    case UiSliderStyle_Enum.SEEK:
      return "SEEK";
    case UiSliderStyle_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseUiSliderStyle(): UiSliderStyle {
  return {};
}

export const UiSliderStyle = {
  encode(_: UiSliderStyle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiSliderStyle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiSliderStyle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UiSliderStyle {
    return {};
  },

  toJSON(_: UiSliderStyle): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UiSliderStyle>, I>>(base?: I): UiSliderStyle {
    return UiSliderStyle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiSliderStyle>, I>>(_: I): UiSliderStyle {
    const message = createBaseUiSliderStyle();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
